import Apis from "../api/api";

export async function functionGetSummary() {
    let summary = await Apis.getSummary()
    return summary
}